export class StringManager {
    load(name, module) {
        if (!module || !this._isValidModuleName(name)) {
            return;
        }
        this[name] = module;
    }
    override(name, overrideStrings) {
        if (!module || !this._isValidModuleName(name)) {
            return;
        }
        if (!this[name]) {
            this.load(name, overrideStrings);
        }
        else {
            const moduleStrings = this[name];
            Object.keys(overrideStrings).forEach((key) => {
                moduleStrings[key] = overrideStrings[key];
            });
        }
    }
    _isValidModuleName(name) {
        return name && name !== 'load' && name !== 'override';
    }
}
export default StringManager;



// WEBPACK FOOTER //
// ./node_modules/@ps/payscale-shared-ui/lib/StringManager/index.js